<template>
	<div class="form-container">
		<h3 class="vrnu-headline">{{ formData }}</h3>
		<b-form v-on:submit.prevent="save">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<div v-if="isUpdate">
							<b-form-group
								label="Identifikator"
								label-for="key">
								<b-form-input id="key"
									type="text"
									placeholder="Identifikator"
									v-model.trim="customer.key"
									v-validate="'required'"
									data-vv-name="Identifikator"
									:class="{'has-error': errors.has('Identifikator')}">
								</b-form-input>
								<p v-if="errors.has('Identifikator')" class="error-message">
									{{ errors.first('Identifikator') }}
							    </p>
							</b-form-group>
						</div>
						<div v-else>
							<b-form-group	label="Geburtsdatum"
											label-for="birthdate">
								<vue-date-picker	v-model.trim="customer.birthdate"
													placeholder="Geburtsdatum"
				                    	    		v-bind:config="{
				                    	    			format: 'DD.MM.YYYY',
														locale: 'de',
														showTodayButton: true,
														showClose: true,
														}"
													data-vv-name="Geburtsdatum"
													v-validate="'required'"
													:class="{'is-invalid': errors.has('Geburtsdatum')}">
		     					</vue-date-picker>
		     					<p v-if="errors.has('Geburtsdatum')" class="error-message">
									{{ errors.first('Geburtsdatum') }}
								</p>
							</b-form-group>		     
							<b-form-group
								label="IBAN"
								label-for="iban">
								<b-form-input id="iban"
									type="text"
									placeholder="IBAN"
									v-model.trim="customer.iban"
									v-validate="'required|checkIbanForValidity'"
									data-vv-name="IBAN"
									:class="{'has-error': errors.has('IBAN')}">
								</b-form-input>
								<p v-if="errors.has('IBAN')" class="error-message">
									{{ errors.first('IBAN') }}
							    </p>
							</b-form-group>																		
							<b-form-group
								label="Identifikator"
								label-for="key"
								description="Der Identifikator wird automatisch aus dem Geburtsdatum und der IBAN des Kunden generiert.">
								<b-form-input id="key"
									type="text"
									placeholder="Identifikator"
									v-bind:value="generatedKey"
									disabled
									data-vv-name="Identifikator"
									:class="{'has-error': errors.has('Identifikator')}">
								</b-form-input>
								<p v-if="errors.has('Identifikator')" class="error-message">
									{{ errors.first('Identifikator') }}
							    </p>
							</b-form-group>
						</div>
					</b-col>
				</b-row>
			</b-container>
			<b-button type="submit" class="vrnu-button" variant="primary">Speichern</b-button>
			<b-button type="reset" variant="secondary">Zurücksetzen</b-button>
		</b-form>		
	</div>
</template>

<script>
// Organize imports
var moment = require('moment');
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import { checkIbanForValidity } from '../../validator/checkIbanForValidity.js';


export default {
	data: function() {
		return {
			isUpdate: false,
			customer: {
				key: '',
				iban: '',
				birthdate: '',
			},
		};
	},
	computed: {
	},
	methods: {
		save: function() {
			this.$validator.validate().then(result => {
				if (result) {
					if(this.isUpdate) {
						var data = {
							key: this.customer.key,
						};
						
						// Update the customer
		 				this.$http.put('customers/' + this.updateId, data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});				
					} else {		
						var data = {
							key: this.generatedKey,
						};

						// Save the customer
						this.$http.post('customers', data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});
					}
				}
			});
		},
		loadCustomerForUpdate: function() {
			// Get customer from server
			this.$http.get('customers/' + this.updateId).then(customer => {
				this.customer = {
					key: customer.body.key,
					// birthdate: moment(customer.body.birthdate).format("DD.MM.YYYY"),
				};
			}, response => {
				// TODO: find a solution
				this.coupon = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		checkIfModeIsUpdate: function() {
			if(this.updateId !== null) {
				this.isUpdate = true;
				this.loadCustomerForUpdate();
			} else {
				this.isUpdate = false;
			}
		},
		moment: function() {
			return moment();
		},
	},
	computed: {
		generatedKey: function() {			
			// Split the strings
			var birthdateArray = this.customer.birthdate.split("");
			var ibanArray = this.customer.iban.split("");
			
			// Build the identificator
			var identificator = (typeof birthdateArray[1] !== 'undefined') ? (birthdateArray[1]) : ("X");
			identificator += (typeof birthdateArray[4] !== 'undefined') ? (birthdateArray[4]) : ("X");
			identificator += (typeof birthdateArray[6] !== 'undefined') ? (birthdateArray[6]) : ("X");
			identificator += (typeof birthdateArray[7] !== 'undefined') ? (birthdateArray[7]) : ("X");
			identificator += (typeof birthdateArray[8] !== 'undefined') ? (birthdateArray[8]) : ("X");
			identificator += (typeof birthdateArray[9] !== 'undefined') ? (birthdateArray[9]) : ("X");
			identificator += (typeof ibanArray[2] !== 'undefined') ? (ibanArray[2]) : ("X");
			identificator += (typeof ibanArray[3] !== 'undefined') ? (ibanArray[3]) : ("X");
			identificator += (typeof ibanArray[19] !== 'undefined') ? (ibanArray[19]) : ("X");
			identificator += (typeof ibanArray[20] !== 'undefined') ? (ibanArray[20]) : ("X");
			identificator += (typeof ibanArray[21] !== 'undefined') ? (ibanArray[21]) : ("X");
				
			// Return the identificator
			return identificator;	
		}
	},
	watch: {
		updateId: function() {
			this.checkIfModeIsUpdate();
		},
	},
	created: function() {
		this.checkIfModeIsUpdate();
		this.$validator.localize('de');
		
		// Extend the validator
		this.$validator.extend('checkIbanForValidity', checkIbanForValidity);
	},
	mounted: function() {
	},
	props: {
		formData: {
			required: true,
		},
		updateId: {
			default: null,
		}
	},
	components: {
		'vue-date-picker': DatePicker,
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.mb-3 {
	margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/05_customer/CustomersForm.vue